import { EnvType } from "./enum";
export const CUSTOM_CHANNEL_NAME = "urn:x-cast:com.nexus.channel";
export const CURRENT_ENV = EnvType.Test;
export const ENABLE_LOGGING = false; //CURRENT_ENV === EnvType.Dev;
